import React, { useState } from "react";
import FALLBACK from "components/icons/image_icon.svg";

interface ImageProps {
  className?: string;
  src: string | null | undefined;
  alt?: string | null | undefined;
  fallback?: string;
  onFailure?: (url: string) => void;
}

export const Image: React.FC<ImageProps> = ({
  className = "",
  src,
  alt,
  fallback,
  onFailure,
}) => {
  const [loaded, setLoaded] = useState(false);

  const onError = (e: React.SyntheticEvent<HTMLImageElement, Event>) => {
    console.warn(`Error loading image ${e.currentTarget.src} -- showing fallback.`);
    onFailure?.(e.currentTarget.src);
    e.currentTarget.src = fallback ?? FALLBACK;
    setLoaded(true);
  };

  const style = {
    opacity: loaded ? 1 : 0,
    transition: "opacity 0.1s ease-in-out",
  };

  return (
    <img
      className={className}
      style={style}
      loading="lazy"
      src={src ?? fallback ?? FALLBACK}
      alt={loaded ? alt ?? "" : ""}
      onError={onError}
      onLoad={() => setLoaded(true)}
    />
  );
};
